import {Component, OnInit, Input, OnDestroy} from '@angular/core';
import {PopoverController} from '@ionic/angular';
import {AccountBalanceService} from '../../services/balance/account-balance.service';
import {GameHubControllerService} from '../../services/gameHub/game-hub-controller';
import {Navigator} from '../../components/menu/navigator';
import {take, last} from 'rxjs/operators';
import {MarketingNotificationService} from 'src/app/services/marketing-notification/marketing-notification.service';
import {UtilsService} from 'src/app/services/utils/utils.service';
import {OnDepositService} from 'src/app/services/on-deposit/on-deposit.service';
import {NavOverriderService} from '../../services/navOverrider/nav-overrider.service';

export enum NotificationEventType {
  MARKETING_OFFER = 'MARKETING_OFFER',
  DEPOSIT = 'DEPOSIT',
  REFER_FRIEND = 'REFER_FRIEND',
  MFREESPIN = 'MFREESPIN',
  COUPON_CODE = 'COUPON_CODE',
  LEADERBOARD = 'LEADERBOARD',
  DRAW = 'DRAW'
}

@Component({
  selector: 'app-popover-marketing',
  templateUrl: './popover-marketing.component.html',
  styleUrls: ['./popover-marketing.component.scss'],
})
export class PopoverMarketingComponent implements OnInit, OnDestroy {
  @Input() data: any;
  private triggeredNewNotification = false;
  private actionButtonTrigger = false;
  private campaignId;
  public notificationEvent;

  constructor(
    private balanceService: AccountBalanceService,
    private popOverCtrl: PopoverController,
    private gameHubService: GameHubControllerService,
    private navigator: Navigator,
    private marketingService: MarketingNotificationService,
    public utils: UtilsService,
    private onDepositService: OnDepositService,
    private navOverride: NavOverriderService
  ) {
     // logout service will dismiss all modals itself
    // this.eventService.subscribe('event:authentication:logout', () => {
    //   this.closePopover();
    // });
  }
  notificationStrategies = {
    [NotificationEventType.DEPOSIT]: {
      text: 'Deposit Now',
      clickEvent: this.onDepositClick.bind(this),
    },
    [NotificationEventType.MFREESPIN]: {
      text: 'Play Now',
      clickEvent: this.onPlayFreeSpinClick.bind(this),
    },
    [NotificationEventType.COUPON_CODE]: {
      text: 'Claim Now',
      clickEvent: this.onCouponClick.bind(this),
    },
    [NotificationEventType.LEADERBOARD]: {
      text: 'Claim Now',
      clickEvent: this.onCouponClick.bind(this),
    },
    [NotificationEventType.DRAW]: {
      text: 'Claim Now',
      clickEvent: this.onCouponClick.bind(this),
    },
  };
  ngOnInit(): void {
    this.notificationEvent = this.data;
    this.campaignId = this.notificationEvent.customField1;
  }
  onPlayFreeSpinClick() {
    this.balanceService.updateBalance();
    this.balanceService
      .getBalance()
      .pipe(take(2), last())
      .subscribe({
        next:(response: any) => {
          if (response) {
            const spins = response.MFREESPIN.availableBalance
              ? response.MFREESPIN.availableBalance
              : 0;
            this.gameHubService.launchDailySpin(spins);
          }
        },
        error: () => {
          console.error('Webservice balance errror.');
        }
    });
    this.navigator.dismiss;
  }

  onDepositClick() {
    this.actionButtonTrigger = true;
    this.navOverride.setCustomCloseFunction(() => {
      this.customCloseFunction();
    });
    this.onDepositService.deposit(this.campaignId);
    try{
      this.navigator.activePopovers[this.navigator.activePopovers.length-1].dismiss();
     }catch(e){
        console.log("Popover Close Error",e)
        this.popOverCtrl.dismiss();
      }
  }

  onCouponClick() {
    this.actionButtonTrigger = true;
    this.navOverride.setCustomCloseFunction(() => {
      this.customCloseFunction();
    });
    this.navigator.navigateTo(
      'RedeemBonusCodeComponent',
      {},
      {bonusCode: this.notificationEvent.customField5}
    );
    try{
    this.navigator.activePopovers[this.navigator.activePopovers.length-1].dismiss();
   }catch(e){
      console.log("Popover Close Error",e)
      this.popOverCtrl.dismiss();
    }
  }

  onNoThankYouClick() {
    this.marketingService
      .callMarkNotificationAsDelivered(this.notificationEvent.id)
      .subscribe({
        next: (response: any) => {
          if (response) {
            console.log(response + 'mark notification as delivered posted');
            this.closePopover();
          }
        },
       error: error => {
          console.log(error);
        }
    });
  }

  isMarketingOffer() {
    return this.notificationEvent.type == NotificationEventType.MARKETING_OFFER;
  }
  getButtonProperties() {
    const eventType = this.notificationEvent.customField4;
    if (eventType === 'DRAW' && this.notificationEvent?.customField6 !== 'LOYALTY_DRAW_ENTRY') {
      return undefined;
    }
    return this.notificationStrategies[eventType];
  }

  closePopover() {
    this.navOverride.setCustomCloseFunction(undefined);
    try{
      this.navigator.activePopovers[this.navigator.activePopovers.length-1].dismiss();
     }catch(e){
        console.log("Popover Close Error",e)
        this.popOverCtrl.dismiss();
      }
    if (!this.triggeredNewNotification) this.triggeredNewNotification = true;
    this.notificationClose();
  }

  notificationClose() {
    if (this.notificationEvent.onCloseFunc && typeof this.notificationEvent.onCloseFunc === 'function')
      this.notificationEvent.onCloseFunc('closeButton');
  }

  ngOnDestroy() {
    if (!this.triggeredNewNotification && !this.actionButtonTrigger) this.notificationClose();
  }

  private customCloseFunction() {
    this.actionButtonTrigger = false;
    this.navOverride.setCustomCloseFunction(undefined);
    this.notificationClose();
    this.navigator.dismissAll();
  }
}
